var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToolsFibonacci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 11.4996V41.0236",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9512 35.1209H50.4836",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4883 50V35.1209",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4845 41.0236H41.4883",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 35.1209C26.8125 22.0752 37.4959 11.4996 50.4826 11.4996C71.6342 11.4996 89 28.6547 89 50",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4826 41.0236C50.4826 46.0459 46.4311 50 41.4863 50C33.4325 50 26.8125 43.3384 26.8125 35.1209",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 88.5004V58.971",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.049 64.8791H50.4824",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4141 50V64.8791",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 58.971H59.4137",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1274 78.0321C16.6767 71.024 11.998 61.0762 11.998 50",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0042 76.4895C66.9436 83.6602 59.2493 88.5004 50.4818 88.5004C42.273 88.5004 34.6289 85.9059 28.3516 81.4794",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0569 64.8791C74.0569 67.1805 73.7266 69.405 73.1113 71.508",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 58.971C50.4824 53.9487 54.4792 50 59.4137 50C67.4506 50 74.0572 56.6616 74.0572 64.8791",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4102 50H41.4849",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 50H21.9878",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5781 73.5495V50",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.48 58.9409H35.5781",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4844 50V58.9409",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5795 73.6622C22.5558 73.6622 11.998 62.9815 11.998 50C11.998 28.8569 29.1718 11.4996 50.4814 11.4996",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4838 50C46.4977 50 50.48 54.0972 50.48 59.0401C50.48 67.0906 43.7819 73.6622 35.5781 73.6622",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0002 50H59.4141",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3379 26.4505V50",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4824 41.0236H65.3389",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4141 50V41.0236",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3389 26.3378C78.4064 26.3378 88.9998 37.0185 88.9998 50C88.9998 71.1431 71.8637 88.5004 50.4824 88.5004",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1426 27.6771C61.0268 26.8181 63.1252 26.3378 65.3398 26.3378",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4137 50C54.383 50 50.4824 45.9665 50.4824 41.0236C50.4824 37.0423 52.1027 33.4072 54.7362 30.7495",
    stroke: "#344054",
    strokeWidth: 1.93159,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolsFibonacci);
export default __webpack_public_path__ + "static/media/Icon_tools_fibonacci.17959258e55503038407dfaebbdbcc5e.svg";
export { ForwardRef as ReactComponent };